import styled from 'styled-components'

export const OnlineNowDot = styled.div`
  margin-bottom: 1px;
  border-radius: 50%;
  display: inline-block;
  width: 0.5rem;
  align-self: center;
  height: 0.5rem;
  margin-right: 5px;
  background-color: #95b94f;
`

export const FormattedDateSpan = styled.span`
  font-size: .875rem;
  margin-right: .5rem;
  color: ${(props) => props.theme.colors.textColor};
  display: inline;
`